import styled from 'styled-components';

import { useDeliveryDate } from '@services/Shared';
import { Price } from '@components/products';
import { Quantity, RemoveCartItem, CartProductInfo } from '@components/cart';
import { HideMobile } from '@components/styles/CommonStyles';

const CartItem = ({ product }) => {
    const {
        quantity,
        id,
        stock,
        name,
        pre_order: preOrder,
        total_pack_count: totalPackCount,
        pack_price: packPrice,
        pack_count: addedPackCount,
        model_id: modelID,
        discount_rate: discountRate,
        discounted_pack_price: discountedPrice,
    } = product;
    const { data } = useDeliveryDate(id, true);

    const sizes = product?.sizes[0]?.map((size) => size.size_label).join(', ');

    return (
        <CartItemWrapper outOfStock={stock === 0} data-testid="cart-item">
            <CartItemContent>
                <CartItemRow>
                    <CartProductInfo
                        showDescription
                        sizes={sizes}
                        deliveryTime={data?.data}
                        item={product}
                        outOfStock={stock === 0}
                        stock={stock}
                        preOrder={preOrder}
                        discountRate={discountRate}
                    />
                </CartItemRow>
            </CartItemContent>
            <HideMobile>
                <Quantity
                    quantity={quantity}
                    productID={id}
                    avalaibleStock={totalPackCount}
                    addedPackCount={addedPackCount}
                    preOrder={preOrder}
                />
            </HideMobile>
            <CartItemPriceContainer>
                <Price
                    withoutDiscountRate
                    price={packPrice}
                    discountedPrice={discountedPrice}
                    discountRate={discountRate}
                />
                <RemoveCartItem productID={id} modelID={modelID} name={name} />
            </CartItemPriceContainer>
        </CartItemWrapper>
    );
};

const CartItemWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: ${({ theme }) => `1px solid ${theme.colors.bgGray10}`};
    padding: 10px 15px;
    background-color: ${({ outOfStock, theme }) =>
        outOfStock ? `${theme.colors.bgGray25}` : `${theme.colors.secondary}`};

    :first-child {
        border: none;
    }

    @media (max-width: 768px) {
        padding: 10px;
        align-items: unset;
    }
`;
const CartItemContent = styled.div`
    display: flex;
    width: 50%;
    align-items: center;
    @media (max-width: 768px) {
        width: unset;
    }
`;
const CartItemRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    @media (max-width: 768px) {
        padding: 5px;
    }
`;
const CartItemPriceContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 25%;

    @media (max-width: 768px) {
        width: unset;
        flex-direction: column-reverse;
        padding-bottom: 10px;
        padding-top: 10px;
    }
`;

export default CartItem;
